import http from '../../../services/api'
import type { APIResponse, Filters, APIPaginatedResponse, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'
import { ITEM_GROUP } from '../../../constants/ItemGroup'
import type { ServiceApi, ServiceCreateApi } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

const SERVICE_ITEM_GROUP_ID = ITEM_GROUP.find((g) => g.name === 'Service')?.value

async function getServices(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  const itemGroupParam =
    SERVICE_ITEM_GROUP_ID != null ? `${paramString ? '&' : '?'}item_group_id=${SERVICE_ITEM_GROUP_ID}` : ''
  return await http.get<APIPaginatedResponse<ServiceApi>>(`${apiPath}items${paramString}${itemGroupParam}`)
}

async function deleteService(serviceUuid: string) {
  return await http.delete<APIResponse<boolean>>(`${apiPath}items/${serviceUuid}`)
}

async function createService(input: ServiceCreateApi) {
  const payLoad = {
    name: input.name,
    code: input.code,
    unit_id: 1,
    item_group_id: SERVICE_ITEM_GROUP_ID,
    item_category_uuid: input.item_category_uuid,
    item_type_uuid: input.item_type_uuid,
    loyalty_applicable: input.loyalty_applicable,
    price: input.price,
    image_url: input.image_url,
    description: input.description,
    preparation_time: input.preparation_time,
    special_tags: input.special_tags,
  }

  return await http.post<APIResponse<ServiceApi>>(`${apiPath}items`, payLoad)
}

async function updateService(input: ServiceApi) {
  const payLoad = {
    name: input.name,
    code: input.code,
    unit_id: 1,
    item_group_id: input.item_group_id,
    item_category_uuid: input.item_category_uuid,
    item_type_uuid: input.item_type_uuid,
    loyalty_applicable: input.loyalty_applicable,
    price: input.price,
    image_url: input.image_url,
    description: input.description,
    preparation_time: input.preparation_time,
    special_tags: input.special_tags,
  }

  return await http.patch<APIResponse<ServiceApi>>(`${apiPath}items/${input.uuid}`, payLoad)
}

const servicesService = {
  getServices,
  deleteService,
  createService,
  updateService,
}

export default servicesService
